// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"87c4253e","522":"0c63dfb8","682":"0f639053","715":"0d4ee80a"}[chunkId] + ".chunk.js";
};